import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ag-grid-enterprise-options',
	templateUrl:'./AgGridEnterpriseOptionsPluginCompPage.html',
	styles: [],
	styleUrls:['./AgGridEnterpriseOptionsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class AgGridEnterpriseOptionsPluginCompPage
{
	mdContent_724 = `\`\`\`java
import com.jwebmp.plugins.aggridenterprise.AgGridEnterpriseOptions;
\`\`\``;
	mdContent_725 = `\`\`\`java
AgGridEnterpriseOptions()
\`\`\``;
	mdContent_726 = `\`\`\`java
AgGridEnterpriseOptions&lt;?&gt; options = new AgGridEnterpriseOptions&lt;&gt;();
options.configureCharts()
    .setEnableCharts(true)
    .setChartThemes(List.of("ag-default", "ag-material"));
options.configureAggregation()
    .setAggregateOnlyChangedColumns(true);
options.configurePivoting()
    .setPivotMode(true);
\`\`\``;
	mdContent_727 = `\`\`\`java
AgGridEnterpriseOptions&lt;?&gt; options = new AgGridEnterpriseOptions&lt;&gt;();
options.serverSideRowModelOptions()
    .setServerSideDatasource("myDatasource")
    .setCacheBlockSize(100);
\`\`\``;
	mdContent_728 = `\`\`\`java
AgGridEnterpriseOptions&lt;?&gt; options = new AgGridEnterpriseOptions&lt;&gt;();
options.configureSideBarAndStatusBar()
    .setSideBar(true);
options.configureRangeSelection()
    .setEnableRangeSelection(true);
\`\`\``;
}
